import React, { FunctionComponent, ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
//import TabsNameInput from '../Inputs/TabsNameInput'
//import LDTooltip from 'components/LDTooltip/LDTooltip';
import Input from "./Input";
import TabsView, { ITabProperties } from "./TabsView";
import Select from '../components/select/Select'

interface ITabsSearchSelectProps {
  tabs: ITabProperties[];
  infoTitle: string;
  searchByNameValue?: string;
  selectedItems?: any;
  children: ReactNode;
  overflow?: string;
  resetDisabled?: boolean;
  inputSelect?: boolean;
  searchByNameHandler?: (e: any) => void;
  setSelectedTab: (e: any) => void;
  onRemovedItemHandler?: (e?: any, item?: any) => void;
  resetSelectedValues?: (e: any) => void;
}


interface IListChildrenStyledProps {
  overflow?: string;
}

const TabsSearch: FunctionComponent<ITabsSearchSelectProps> = ({
  tabs,
  infoTitle,
  searchByNameValue,
  selectedItems,
  searchByNameHandler,
  setSelectedTab, 
  onRemovedItemHandler,
  resetDisabled,
  inputSelect,
  resetSelectedValues,
  children,
  overflow = "true"
}) => {
  const [inputValue, setInputValue] = useState<any>('')

  useEffect(() => {
    if(inputSelect) setInputValue('')
  }, [selectedItems, inputSelect])

  const handleMultiValueRemove = (event: any, props: any) => {
    event.preventDefault()
    onRemovedItemHandler && onRemovedItemHandler([props?.data])
  }

  const onInputChangeHandler = (event: any, actions: any) => {
    if(actions?.action === 'input-change') {
      setInputValue(event)
      searchByNameHandler && searchByNameHandler(event)
    }
  }

  return (
    <>
    {searchByNameHandler && (
      <SearchFieldWrap>
        {inputSelect ? (
          <Select 
            menuIsOpen={false}
            isClearable={false}
            isMultiRemove
            placeholder="Search by name..."
            value={selectedItems.map((selectedItem: any) => { return {label: selectedItem?.title, ...selectedItem} })}
            inputValue={inputValue}
            onInputChange={onInputChangeHandler}
            handleMultiValueRemove={handleMultiValueRemove}
          />
        ) : (
          <Input
            placeholder="Search by name"
            onChangeHandler={(e: any) => searchByNameHandler(e)}
          />
        )}
      </SearchFieldWrap>
    )}
      {(Array.isArray(tabs) && tabs.length > 0) || resetSelectedValues ? (
        <TabsView
          infoTitle={infoTitle}
          tabs={tabs}
          onSwitchTab={(e) => setSelectedTab(e)}
          onReset={resetSelectedValues ? (e: any) => resetSelectedValues(e) : undefined}
        />
      ) : null}
      <ListChildren overflow={overflow}>{children}</ListChildren>
    </>
  );
};
const ListChildren = styled.div<IListChildrenStyledProps>`
  max-height: 324px;
  ${(props) => props.overflow && "overflow: auto"};
`;

const SearchFieldWrap = styled.div`
  margin-bottom: 9px;
`;

export default TabsSearch;
